import React,{useEffect,useRef,useState} from 'react';
import {api} from '../context/AuthContext';
import {Link} from 'react-router-dom';
import {bookReadingRoute} from './BookSourceReader';
export default function AnswerEvidence({evidence=[]}){
 const [current,setCurrent]=useState([]),[verifiedFor,setVerifiedFor]=useState(''),[error,setError]=useState(''),[busy,setBusy]=useState(false);
 const panel=useRef(null),generation=useRef(0),identity=JSON.stringify(evidence);
 useEffect(()=>{
  const clear=()=>{generation.current++;setCurrent([]);setVerifiedFor('');setError('');setBusy(false);if(panel.current)panel.current.open=false;};
  const visibility=()=>{if(document.hidden)clear();};
  clear();window.addEventListener('blur',clear);document.addEventListener('visibilitychange',visibility);
  return()=>{generation.current++;window.removeEventListener('blur',clear);document.removeEventListener('visibilitychange',visibility);};
 },[identity]);
 async function check(){
  const n=++generation.current;setCurrent([]);setVerifiedFor('');setError('');setBusy(false);
  if(!panel.current?.open)return;
  setBusy(true);
  try{
   const fresh=await Promise.all(evidence.map(async old=>{
    if(!old.id)throw new Error('SOURCE_NOT_AVAILABLE');
    const {data}=await api.get('/mahmut/passages/'+encodeURIComponent(old.id)+'/source');
    if(data.id!==old.id||data.source_id!==old.source_id||typeof data.text!=='string')throw new Error('SOURCE_NOT_AVAILABLE');
    return data;
   }));
   if(n===generation.current&&panel.current?.open&&!document.hidden){setCurrent(fresh);setVerifiedFor(identity);}
  }catch{if(n===generation.current)setError('Kaynak şu anda erişilebilir değil.');}
  finally{if(n===generation.current)setBusy(false);}
 }
 return <details ref={panel} onToggle={check}><summary>Kaynaklar ({evidence.length})</summary>{busy&&<p role="status">Kaynak erişimi kontrol ediliyor…</p>}{verifiedFor===identity&&current.map((s,i)=><article key={s.id||i} className="my-4"><strong>[{i+1}] {s.title}</strong><p>{s.pdf_page?`PDF sayfa ${s.pdf_page}`:`${s.start_seconds}–${s.end_seconds}. saniye`}</p><blockquote className="chat-message" dir="auto">{s.text}</blockquote>{bookReadingRoute(s)&&<p><Link className="inline-flex min-h-[44px] items-center underline" to={bookReadingRoute(s)}>Kitabı sayfada oku</Link></p>}{s.url&&/^https:\/\/drive\.google\.com\/file\/d\/[A-Za-z0-9_-]+\/view$/.test(s.url)&&<a href={s.url} target="_blank" rel="noopener noreferrer">Kaynağı aç ↗</a>}</article>)}{error&&<p role="status">{error}</p>}</details>;
}
